import React from 'react';
import { companyInfo } from '../data/mock';

const AboutSection = () => {
  return (
    <section className="py-12 px-4 bg-[#f5f5f0]">
      <div className="max-w-4xl mx-auto">
        {/* Main Heading */}
        <h2 className="text-xl md:text-2xl font-semibold text-[#FFDA00] mb-6 leading-relaxed">
          {companyInfo.description.intro}
        </h2>

        {/* Description Paragraphs */}
        <div className="space-y-4 text-gray-700 leading-relaxed">
          <p className="text-base">{companyInfo.description.model}</p>
          <p className="text-base">{companyInfo.description.exports}</p>
          <p className="text-base">{companyInfo.description.values}</p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
